import React, { useEffect, useState } from "react";

// MUI
import {
  Stack,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";

// Styles
import { buttonStyles } from "Common/Styles";

const ReviewUpdateDialog = ({
  open,
  onClose,
  onConfirm,
  account,
  reviewPage,
  finishLoading,
}) => {
  const [loading, setLoading] = useState(false);

  // Close dialog when loading is finished
  useEffect(() => {
    if (finishLoading) {
      onClose();
    }
  }, [finishLoading, onClose]);

  return (
    <Dialog maxWidth="md" open={open} onSubmit={onConfirm} onClose={onClose}>
      <DialogTitle>Review {account} Changes</DialogTitle>
      <DialogContent>
        <Stack gap={2}>{reviewPage}</Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose} sx={buttonStyles.cancelButton}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={loading}
          onClick={() => {
            onConfirm();
            setLoading(true);
          }}
          sx={{ ...buttonStyles.greenActionButton, px: 2 }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} sx={{ color: "white" }} />
              Updating...
            </>
          ) : (
            <>Update {account}</>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReviewUpdateDialog;
